import { http } from 'src/services/mail/http'
import { IGetConnectedAccounts } from 'src/store/modules/email/actions'
import { ICustomLabel } from 'src/store/modules/email/types'
import { IDeleteThreads, IGetMailAccounts, IPostToggleLabel } from './type'

export interface IGetConnectedMails {
  data: {
    id: number
    identifier: string
    status: string
    type: 'private' | 'public'
    userId: number
  }[]
}

export interface IDeleteCustomLabel {
  label: string
}

export interface ICreateCustomLabel {
  label: string
  isHidden: boolean
  color?: string
}

export interface IUpdateCustomLabel {
  label: string
  isHidden: boolean
  color?: string
  code: string
}

export interface IGetThreads {
  labels?: string
  page?: number
  emails?: string
  search?: string
  subscriberStorageId?: string
  perPage?: number
}

export interface IGetCustomLabels {
  perPage?: number
  cursor?: string
  color?: string
}

export interface IUnlinkEmail {
  accountId: number
}

export const getThreads = ({
  page = 1,
  labels = 'inbox',

  ...params
}: IGetThreads) => {
  return http.get<IGetThreads>(`/threads`, {
    params: {
      page,
      labels,
      ...params,
    },
  })
}
export enum MailDrivers {
  GMAIL = 'gmail',
  HOTEMAIL = 'hotmail',
}

export interface IGetAssignLink {
  driver: MailDrivers
}

export interface IAssignLink {
  link: string | null
}

export const getAssignLink = async ({ driver }: IGetAssignLink) =>
  await http.get<IAssignLink>(`/oauth/${driver}/link`)

export interface ISentMessage {
  account: number
  body: string
  subject: string
  recipients: { email: string; type: RecipientType }[]
  attachments: File[]
  mimeType?: string
  reply?: boolean
  emailId?: number
}

export enum RecipientType {
  TO = 'to',
  CC = 'cc',
  BCC = 'bcc',
}
export const sendEmail = ({
  account,
  mimeType = 'text/html',
  emailId,
  ...params
}: ISentMessage) => {
  const URL = emailId ? `/threads/reply/${emailId}` : `/threads/send/${account}`

  return http.post(
    URL,
    {
      mimeType,
      ...params,
    },
    { headers: { 'Content-Type': 'multipart/form-data' } }
  )
}

export const getConnectedMails = (params: IGetConnectedAccounts) =>
  http.get('/accounts', { params })

export interface IGetThread {
  thread: string
}

export const getThread = ({ thread }: IGetThread) => {
  return http.get(`/threads/${thread}`)
}

export interface IChangeThreadPrivateMode {
  threadId: string
  privacyMode: 'share' | 'private'
}

export const changeThreadPrivateMode = ({
  threadId,
  privacyMode,
}: IChangeThreadPrivateMode) => {
  return http.patch(`/threads/${threadId}/${privacyMode}`)
}

export interface IChangeThreadLabelsSaga {
  operation: 'del' | 'add'
  threadIds: string[]
  labelsCodes: ICustomLabel[]
  isTargetedThread?: boolean
}

export interface IChangeThreadLabelsReq {
  operation: 'del' | 'add'
  threadIds: string[]
  labelsCodes: string[]
}

export const getCustomLabels = (params: IGetCustomLabels) => {
  return http.get<IGetCustomLabels>(`/labels`, { params })
}

export const createCustomLabel = (params: ICreateCustomLabel) =>
  http.post(`/labels`, params)

export const deleteCustomLabel = (params: IDeleteCustomLabel) => {
  http.delete(`/labels/${params.label}`)
}

export const updateCustomLabel = (params: IUpdateCustomLabel) => {
  http.patch(`/labels/${params.code}`, { ...params })
}

export const unlinkEmail = ({ accountId }: IUnlinkEmail) => {
  http.patch(`/accounts/${accountId}/unlink`)
}

export interface IToggleMailAccountPrivacy {
  accountId: number
}
export const accountMakePublic = ({ accountId }: IToggleMailAccountPrivacy) => {
  http.patch(`/accounts/${accountId}/make-public`)
}

export const accountMakePrivate = ({
  accountId,
}: IToggleMailAccountPrivacy) => {
  http.patch(`/accounts/${accountId}/make-private`)
}

export const getMailAccounts = (params: IGetMailAccounts) =>
  http.get('/accounts', { params })

export const deleteThreads = (params: IDeleteThreads) =>
  http.delete(`/threads`, { params })

export const postToggleThreadLabel = ({
  labelsCodes,
  operation,
  ...params
}: IPostToggleLabel) => {
  return http.post(`/threads/labels/${operation}`, {
    labelsCodes: [labelsCodes],
    ...params,
  })
}
